<h1 mat-dialog-title class="p-2 text-center">Nouveau Comptage</h1>
<div class="container-fluid p-3">
    <div class="row">

        <!-- <mat-form-field class="col"  >
            <mat-label>Taxon trouvé</mat-label>
            <mat-select placeholder="Taxon trouvé" (selectionChange)="onTaxonSelectionChange($event)">
                <mat-option *ngFor="let t of model.Analyse.MergedTaxonList; " [value]="t">
                    <span > {{t.NomGenre ? t.NomGenre : t.NomFamille}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field> -->

        <mat-form-field class="col" cdkFocusRegionStart>
            <mat-label>Recherche Critère faunistique - floristique</mat-label>
            <input matInput placeholder="Recherche Critère faunistique - floristique" [(ngModel)]="SearchText" [matAutocomplete]="auto" (keyup)="onKeyUp()" [disabled]="!canChooseTaxon()" [focus]="IsFocused"
                   (keyup.enter)="onConfirm()">
            <button appPreventDoubleClick *ngIf="SearchText && IsCreation" matSuffix mat-icon-button aria-label="Clear" (throttledClick)="SearchText=''">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedTaxon($event)" [displayWith]="displayFn">
            <mat-option *ngFor="let option of TaxonOptionList" [value]="option">
                <span *ngIf="!CoreData.IsOffline">
                    {{option.Code}} - {{option?.Ordre && option?.Ordre !== '' ? option?.Ordre + ' /' : ''}} {{option?.Famille !== '' ? option?.Famille + ' /' : ''}} {{option?.Genre}}
                </span>
                <span *ngIf="CoreData.IsOffline">
                    {{option.Code}} - {{option?.Genre}}
                </span>
            </mat-option>
        </mat-autocomplete>
    </div>
    <div class="row">

        <mat-form-field *ngIf="model.Taxon.Instruction" class="col">
            <mat-label>Instruction</mat-label>
            <textarea matInput style="color: darkgoldenrod;" class="font-weight-bold font-italic" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="2" placeholder="Instruction"
                      [(ngModel)]="model.Taxon.Instruction" readonly></textarea>
        </mat-form-field>
    </div>

    <div class="row" *ngIf="model.Analyse.Type !== EInterventionType.IBGN && model.Analyse.Type !== EInterventionType.IBD">

        <mat-form-field  class="col">
            <mat-label>Phase</mat-label>
            <mat-select placeholder="Phase" [(ngModel)]="model.Taxon.NumeroPhase" required (selectionChange)="resetQuantity($event);refreshTransectList()">
                <mat-option *ngFor="let p of PhaseList; let i = index" [value]="p">
                    <span *ngIf="PhaseList.length === 3">{{getPhaseName(p)}}</span>
                    <span *ngIf="PhaseList.length === 4">{{getMGCEPhaseName(i + 1)}}</span>
                    <span *ngIf="PhaseList.length === 12 || PhaseList.length === 15">{{getBullshitPhaseName(i + 1)}}</span>
                    <span *ngIf="model.Analyse.Type === EInterventionType.IBMR">{{getIBMRPhaseName(i + 1)}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col" *ngIf="model.Analyse.Type === EInterventionType.IBMR" >
            <mat-label>Transect</mat-label>
            <mat-select placeholder="Transect" [(ngModel)]="model.Taxon.NumeroTransect" required (selectionChange)="onTransectSelectionChange($event)">
                <mat-option *ngFor="let p of TransectList; let i = index" [value]="p">
                    <span >{{getIBMRTransectName(i + 1)}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput [placeholder]="getQuantiteLabel()" type="number" [(ngModel)]="model.Taxon.Quantite" (keyup.enter)="onConfirm()" [disabled]="IsQuantityDisabled">
        </mat-form-field>
    </div>

    <div class="row" *ngIf="model.Analyse.Type === EInterventionType.IBMR">
        <mat-slide-toggle class="" [(ngModel)]="model.Taxon.Preleve">Prélevé ? </mat-slide-toggle>
    </div>

    <div class="row">
        <mat-form-field class="col-12" cdkFocusRegionEnd>
            <mat-label>Commentaire</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" placeholder="Commentaire" [(ngModel)]="model.Taxon.Comment"
                      (keydown.enter)="onConfirm();false"></textarea>
        </mat-form-field>
    </div>

    <div class="row">
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
            Sauvegarder
        </button>
    </div>
</div>